import { ConfiguredRecordType } from 'containers/GenericFieldsHandlingLayer/types';
import { GeneratorFieldType } from 'common/components/FieldGenerator/types';
import { ExtendedDataStorageType } from 'containers/AdditionalDataStorage/types';
import { LengthType } from 'common/types/additional';
import { toFixedByLengthType } from '@danfloss/views/AssemblyLengthView/utils';
import { DanflossProjectFields } from '@danfloss/containers/project-fields';
import {
  addItem, generateConfigId, getSingleNumberValue, getSingleStringValue,
} from 'api/cart/utils';
import { ICPQCart, ICPQItem } from 'api/cart/types';


export const mapProjectFieldsToProjectDanflossCart = (
  fields: ConfiguredRecordType<DanflossProjectFields, GeneratorFieldType>,
  additional: ExtendedDataStorageType,
): ICPQCart => {
  const items: ICPQItem[] = [];
  const requiredComponents: ICPQItem[] = [];
  const accessories: ICPQItem[] = [];

  addItem(items, 'hose', fields.hoseProduct?.value?.selected);
  addItem(items, 'fitting1', fields.fitting1Product?.value?.selected);
  addItem(items, 'fitting2', fields.fitting2Product?.value?.selected);

  const customerPartNumber = getSingleStringValue(fields.customerSerialNumber?.value?.selected)!;

  // Backend-computed, not rendered in UI/PDF — forwarded into event payload
  // only. Safe when field is absent (undefined) or selected is empty — addItem
  // no-ops on non-array / empty input.
  addItem(requiredComponents, 'required', fields.requiredComponents?.value?.selected);

  addItem(accessories, 'main', fields.accessoryProduct?.value?.selected);

  if (fields.testingConfiguration?.value?.selected) {
    addItem(accessories, 'testing', fields.testingConfiguration?.value?.selected);
  }

  const lengthInInches = getSingleNumberValue(fields.assemblyLength?.value?.selected)!;
  const lengthInFeet = toFixedByLengthType(lengthInInches, LengthType.inches, LengthType.feet);

  // Angle of rotation from the wizard, mirroring useSummary: undefined when the
  // field is absent or disabled. Forwarded into the cart event (was hardcoded
  // undefined, so the wrapper never got it) and into generatedConfigId.
  const angleField = fields.angleOfRotation;
  const angleOfRotation = (angleField && angleField.status !== 'disabled')
    ? getSingleNumberValue(angleField.value?.selected)
    : undefined;

  const assembly = {
    angleOfRotation: angleOfRotation as unknown as number,
    assemblyLength_feet: lengthInFeet,
    assemblyLength_inches: lengthInInches,
    length_type: additional.lengthType,
  };

  return {
    generatedConfigId: generateConfigId([...items, ...accessories, ...requiredComponents], assembly, customerPartNumber),
    quantity: additional.configQuantity,
    items,
    requiredComponents,
    accessories,
    customerPartNumber,
    assemblyProperties: assembly,
  };
};
